import { fetchQuery } from "relay-runtime"
import { useIcdCodeByDiagnosisCodeQuery } from "@/modules/patients/detail/progress-note/hooks/__generated__/useIcdCodeByDiagnosisCodeQuery.graphql"
import { icdCodeByDiagnosisCodeQuery } from "@/modules/patients/detail/progress-note/hooks/useIcdCodeByDiagnosisCode"
import { RelayEnvironment } from "@/relay-environment"

const getDiagnosisCodeByDiagnosisCode = async (diagnosisCode: string | undefined) => {
  let newDiagnosisCode = {
    code: "",
    description: "",
  }
  if (diagnosisCode) {
    const data = await fetchQuery<useIcdCodeByDiagnosisCodeQuery>(RelayEnvironment, icdCodeByDiagnosisCodeQuery, {
      diagnosisCode,
      skip: false,
    }).toPromise()

    if (data?.icdDiagnosisByDiagnosisCode) {
      const { diagnosisCode, text } = data.icdDiagnosisByDiagnosisCode
      newDiagnosisCode = { code: diagnosisCode, description: text }
    }
  }
  return newDiagnosisCode
}

export { getDiagnosisCodeByDiagnosisCode }
